import { Injectable } from '@angular/core';
import { PoliciesContextService } from '@core/services/context/policies-context.service';
import { UiHelperService } from '@core/services/core/ui-helper.service';
import { POLICY_BASE_TYPES } from '@models/policy';
import { TranslateService } from '@ngx-translate/core';
import { jsonClone } from '@utils/utils';

declare const document: any;
declare function Genesys(c: string, f: string, params?: any, resolve?: any, reject?: any): any;
@Injectable({
  providedIn: 'root'
})

export class GenesysChatHelperService {
  constructor(
    private ui: UiHelperService,
    private translate: TranslateService,
    private policiesContext: PoliciesContextService,
  ) {}

  public closeGenesysChat() {
    const genesysApp = document.getElementsByClassName('genesys-app')[0];
    if (genesysApp) {
      Genesys('command', 'Auth.logout');
      Genesys('command', 'Launcher.hide');
      genesysApp.remove();
      document.getElementById('genesys-script')?.remove();
      document.getElementById('genesys-bootstrap')?.remove();
    }
  }

  public showModalInfo(statusResponse) {
    this.ui.presentProfileCustomAlert(
      this.translate.instant('CLIENT_AREA.CHAT_GENESYS.INFO_ALERT.TITLE'),
      'assets/images/result/info.svg',
      statusResponse.message,
      null,
      null,
      this.translate.instant('CLIENT_AREA.CHAT_GENESYS.INFO_ALERT.BUTTON'),
    );
  }

  public showModalError() {
    this.ui.presentProfileCustomAlert(
      this.translate.instant('CLIENT_AREA.CHAT_GENESYS.ERROR_ALERT.TITLE'),
      'assets/images/result/error.svg',
      this.translate.instant('CLIENT_AREA.CHAT_GENESYS.ERROR_ALERT.MESSAGE'),
      null,
      null,
      this.translate.instant('CLIENT_AREA.CHAT_GENESYS.ERROR_ALERT.BUTTON')
    );
  }

  checkOnlyPolicyCar() {
    const policiesByBaseType = jsonClone(this.policiesContext.getPolicies().policiesByBaseType);
    const checkUserPolicies = p => policiesByBaseType[p]?.length > 0;
    const listUserPoliciesTypes = POLICY_BASE_TYPES.filter(checkUserPolicies);
    return listUserPoliciesTypes.length === 1 && listUserPoliciesTypes[0] === 'car';
  }

  clear() {
    localStorage.removeItem('_actmu');
    localStorage.removeItem('_actms');
    localStorage.removeItem('_actts');
    localStorage.removeItem('_actvc');
  }
}


